import { render, staticRenderFns } from "./SignatureCompany.vue?vue&type=template&id=86ba1674&"
import script from "./SignatureCompany.vue?vue&type=script&lang=js&"
export * from "./SignatureCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports